export default __webpack_public_path__ + "img/portrait_2.e3dbdadef3cc2f0bf02a55ace7e0b73a.jpg";